import { AiInterviewConsentStatus } from 'generated/graphql';

/**
 * Whether the consent gate must be shown before anything else happens:
 * consent is required and not given for the current text. Also holds back
 * interview initiation, so a decline never leaves an orphan conference.
 */
export function isAiInterviewConsentPending(
  consent:
    | { isRequired: boolean; status: AiInterviewConsentStatus }
    | null
    | undefined
): boolean {
  return (
    !!consent?.isRequired && consent.status !== AiInterviewConsentStatus.Given
  );
}
